import { NumberTokenValue, StringTokenValue } from 'designSystem/types';
import * as S from './styles';

interface OtherTokenPreviewProps {
	value: NumberTokenValue | StringTokenValue;
}

export const OtherTokenPreview = ({ value }: OtherTokenPreviewProps) => {
	return (
		<S.PreviewContainer>
			<S.SimpleValue>{value.original}</S.SimpleValue>
		</S.PreviewContainer>
	);
};
